// Penyimpanan offline (IndexedDB): modul + soal mini test + audio kosakata, serta antrean jawaban yang disinkronkan saat online.
import { api } from "@/lib/api";

const DB = "yutaka-offline", VER = 1;
const open = () => new Promise((res, rej) => {
  const r = indexedDB.open(DB, VER);
  r.onupgradeneeded = () => { const d = r.result; ["modules", "audio", "queue"].forEach((s) => { if (!d.objectStoreNames.contains(s)) d.createObjectStore(s); }); };
  r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error);
});
const tx = async (store, mode, fn) => { const d = await open(); return new Promise((res, rej) => { const t = d.transaction(store, mode); const q = fn(t.objectStore(store)); t.oncomplete = () => res(q?.result); t.onerror = () => rej(t.error); }); };
const get = (s, k) => tx(s, "readonly", (o) => o.get(k));
const put = (s, k, v) => tx(s, "readwrite", (o) => o.put(v, k));
const del = (s, k) => tx(s, "readwrite", (o) => o.delete(k));
const all = (s) => tx(s, "readonly", (o) => o.getAll());
const keys = (s) => tx(s, "readonly", (o) => o.getAllKeys());

export const isOffline = () => typeof navigator !== "undefined" && navigator.onLine === false;
export const isNetworkError = (e) => !e?.response;

export async function saveModuleOffline(m, onProgress) {
  let test = null;
  try { test = (await api.get(`/modules/${m.id}/test`)).data; } catch { /* exam modules may be large; skip */ }
  const texts = [...new Set([...(m.vocab || []).map((v) => v.jp.replace(/\[([^|\]]+)\|[^\]]*\]/g, "$1")), ...(m.items || []).map((it) => it.word || it.jp).filter(Boolean)])].slice(0, 60);
  let done = 0;
  for (const text of texts) {
    try { if (!(await get("audio", text))) { const { data } = await api.get("/tts", { params: { text }, responseType: "blob" }); await put("audio", text, data); } } catch { /* audio optional */ }
    onProgress?.(++done, texts.length);
  }
  await put("modules", m.id, { module: { ...m, offline: true }, test, saved_at: new Date().toISOString(), audio_count: texts.length });
}

export const removeModuleOffline = (id) => del("modules", id);
export const getOfflineModule = (id) => get("modules", id);
export const listOfflineModules = () => all("modules");
export const getOfflineAudio = (text) => get("audio", text).catch(() => null);
export const offlineIds = () => keys("modules").catch(() => []);

export function gradeLocally(test, answers) {
  const items = test.questions.map((q) => ({ question_id: q.id, type: q.type, level: q.level, prompt_jp: q.prompt_jp, prompt_id: q.prompt_id, options: q.options, chosen: answers[q.id] ?? null, answer: q.answer, correct: answers[q.id] === q.answer, explanation_id: q.explanation_id, explanation_jp: q.explanation_jp }));
  const score = items.filter((i) => i.correct).length;
  const pct = Math.round((score * 100) / Math.max(1, items.length));
  return { id: `local-${Date.now()}`, module_id: test.module_id || test.id, module_title: test.title_id, score, total: items.length, pct, items, breakdown: [], passed: pct >= 60, offline: true };
}

export async function queueSubmit(moduleId, answers) {
  await put("queue", `${moduleId}-${Date.now()}`, { moduleId, answers, at: new Date().toISOString() });
}

export async function flushQueue() {
  if (isOffline()) return 0;
  const ks = await keys("queue").catch(() => []);
  let n = 0;
  for (const k of ks) {
    const job = await get("queue", k);
    try { await api.post(`/modules/${job.moduleId}/test/submit`, { answers: job.answers }); await del("queue", k); n++; } catch (e) { if (!isNetworkError(e)) await del("queue", k); }
  }
  return n;
}

export const queueSize = () => keys("queue").then((k) => k.length).catch(() => 0);
